/**
 * Tool presentation metadata — icon + domain chip.
 * Keyed by tool id (backend source of truth) and icon name (backend `icon` field).
 */

import React from 'react'
import {
  Build as BuildIcon,
  Download as DownloadIcon,
  ContentCopy as ContentCopyIcon,
  AccountBalance as AccountBalanceIcon,
  Assessment as AssessmentIcon,
  Balance as BalanceIcon,
  Inventory2 as Inventory2Icon,
  HealthAndSafety as HealthAndSafetyIcon,
} from '@mui/icons-material'

const ICON_MAP: Record<string, React.ReactElement> = {
  Download: <DownloadIcon />,
  ContentCopy: <ContentCopyIcon />,
  AccountBalance: <AccountBalanceIcon />,
  Assessment: <AssessmentIcon />,
  Balance: <BalanceIcon />,
  Inventory2: <Inventory2Icon />,
  HealthAndSafety: <HealthAndSafetyIcon />,
}

export const getToolIcon = (iconName?: string): React.ReactElement => {
  if (iconName && ICON_MAP[iconName]) return ICON_MAP[iconName]
  return <BuildIcon />
}

export type ToolDomain = 'Sales' | 'Inventory' | 'Products' | 'Accounting'

interface DomainStyle {
  label: ToolDomain
  color: string          // chip text / border
  bg: string             // chip background tint
}

// Poolwerx-aligned palette — unified teal across all domains
const DOMAIN_STYLES: Record<ToolDomain, DomainStyle> = {
  Sales:      { label: 'Sales',      color: '#007f98', bg: 'rgba(0,127,152,0.10)' },
  Inventory:  { label: 'Inventory',  color: '#007f98', bg: 'rgba(0,127,152,0.10)' },
  Products:   { label: 'Products',   color: '#007f98', bg: 'rgba(0,127,152,0.10)' },
  Accounting: { label: 'Accounting', color: '#007f98', bg: 'rgba(0,127,152,0.10)' },
}

const TOOL_DOMAIN: Record<string, ToolDomain> = {
  duplicate_sales:          'Sales',
  invoice_payments_export:  'Sales',
  inventory_balance_review: 'Inventory',
  product_catalogue_review: 'Products',
  cogs_review:              'Accounting',
}

export const getToolDomain = (toolId: string): DomainStyle | null => {
  const domain = TOOL_DOMAIN[toolId]
  return domain ? DOMAIN_STYLES[domain] : null
}
